/**
 * 年同比 / 周环比辅助线：全站统一线宽、虚线样式、颜色。
 * 图表（ECharts）、表格内迷你图（Recharts ReferenceLine）、图例色块均应对齐此配置。
 */
export var COMPARISON_REFERENCE_LINE_WIDTH = 2;
/** SVG / Recharts `stroke-dasharray`，与 ECharts `type: 'dashed'` 视觉一致 */
export var COMPARISON_REFERENCE_STROKE_DASHARRAY = "5 5";
export var COMPARISON_YEAR_OVER_YEAR_COLOR = "#ff4d4f";
export var COMPARISON_WEEK_OVER_WEEK_COLOR = "#1890ff";
/** ECharts combo 折线 series 的 lineStyle */
export var COMPARISON_REFERENCE_ECHARTS_LINE_STYLE = {
    type: "dashed",
    width: COMPARISON_REFERENCE_LINE_WIDTH,
};
export var COMPARISON_REFERENCE = {
    yearOverYear: {
        label: "年同比",
        color: COMPARISON_YEAR_OVER_YEAR_COLOR,
        strokeDasharray: COMPARISON_REFERENCE_STROKE_DASHARRAY,
        lineWidth: COMPARISON_REFERENCE_LINE_WIDTH,
        lineStyle: COMPARISON_REFERENCE_ECHARTS_LINE_STYLE,
    },
    weekOverWeek: {
        label: "周环比",
        color: COMPARISON_WEEK_OVER_WEEK_COLOR,
        strokeDasharray: COMPARISON_REFERENCE_STROKE_DASHARRAY,
        lineWidth: COMPARISON_REFERENCE_LINE_WIDTH,
        lineStyle: COMPARISON_REFERENCE_ECHARTS_LINE_STYLE,
    },
};
